if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.boundMethods = {
          onSubmitHandler: this.onSubmitHandler.bind(this),
        };

        this.elements = {};
      }

      connectedCallback() {
        if (this.dataset.isEmbroidery === 'true') {
          this.elements.textHiddenInput = this.querySelector('input[name="properties[Text]"]');
          this.elements.styleHiddenInput = this.querySelector('input[name="properties[Style]"]');
          this.elements.colorHiddenInput = this.querySelector('input[name="properties[Color]"]');
          this.elements.finalSaleHiddenInput = this.querySelector('input[name="properties[_LPROP]"]');
          this.form.addEventListener('embroidery-atc', this.boundMethods.onSubmitHandler);
        }
      }

      disconnectedCallback() {
        if (this.dataset.isEmbroidery === 'true') {
          this.form.removeEventListener('embroidery-atc', this.boundMethods.onSubmitHandler);
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        if (evt.detail && evt.detail.embroideryProductId) {
          const uuid = crypto.randomUUID();

          config.body.append('[properties][_embroidery_uuid]', uuid);
          config.body.append('[properties][Heads Up]', 'Final sale. No returns or exchanges.');
          config.body.append('items[1][properties][_embroidery_uuid]', uuid);
          config.body.append('items[1][id]', evt.detail.embroideryProductId);
          config.body.append('items[1][quantity]', '1');
          config.body.append('items[1][properties][Heads Up]', 'Final sale. No returns or exchanges.')
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(response);
              });
            }

            // if (window.fbq) {
            //   window.fbq('track', 'AddToCart', {
            //     content_ids: [formData.get('id')],
            //     content_name: formData.get('title'),
            //     content_type: 'product_group',
            //     value: formData.get('price'),
            //     currency: 'USD',
            //   });
            // }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);

            if (evt.detail && evt.detail.embroideryProductId) {
              this.elements.textHiddenInput.disabled = true;
              this.elements.styleHiddenInput.disabled = true;
              this.elements.colorHiddenInput.disabled = true;
              if (this.elements.finalSaleHiddenInput) this.elements.finalSaleHiddenInput.disabled = true;
              this.elements.textHiddenInput.value = '';
              this.elements.styleHiddenInput.value = '';
              this.elements.colorHiddenInput.value = '';
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    },
  );
}
